import { useGT } from 'gt-react';
import type { AgentRetrySnooze } from '@erp/rpc';
import { formatSnoozedUntil } from './taskSnooze';

/**
 * "Matcher will retry at Oct 22, 3:00 PM. Retry 2 of 5 before it goes to a
 * person." with the agent's reason under it.
 */
export function AgentRetrySnoozeText({
  retry,
}: {
  retry: NonNullable<AgentRetrySnooze>;
}) {
  const gt = useGT();
  const when = formatSnoozedUntil(retry.retryAt);
  const context =
    'task snooze banner: an agent snoozed this task and will retry it itself; after the last retry the task is handed to a person';
  const headline = retry.agentName
    ? gt(
        '{agent} will retry at {when}. Retry {attempt} of {max} before it goes to a person.',
        {
          context,
          agent: retry.agentName,
          when,
          attempt: retry.attempt,
          max: retry.maxAttempts,
        },
      )
    : gt(
        'An agent will retry at {when}. Retry {attempt} of {max} before it goes to a person.',
        { context, when, attempt: retry.attempt, max: retry.maxAttempts },
      );
  return (
    <>
      <span className="block">{headline}</span>
      {retry.reason && (
        <span className="block text-amber-900/80">{retry.reason}</span>
      )}
    </>
  );
}
